export default __webpack_public_path__ + "static/media/user.c35b586f.png";